import React from "react";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import Icon from "@mui/material/Icon";
import usePlanner from "features/planner/state/usePlanner";
import logger from "utils/logger";

export default function DownloadPdfButton() {
  const { generateProgramPdf } = usePlanner();

  const handleDownload = async () => {
    try {
      logger.info("Downloading PDF");

      const { blob, filename } = await generateProgramPdf();

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(url);
    } catch (err) {
      logger.error("Error downloading PDF", err);
    }
  };

  return (
    <MDBox
      onClick={handleDownload}
      sx={{
        width: { xs: "100%", md: "90%", lg: "100%" },
        maxWidth: "260px",
        paddingY: "10px",
        paddingX: "16px",
        borderRadius: "14px",
        cursor: "pointer",
        userSelect: "none",

        border: "2px solid",
        borderColor: "secondary.main",
        backgroundColor: "background.paper",
        color: "secondary.main",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",

        transition: "all 0.18s ease",

        "&:hover": {
          backgroundColor: "grey.100",
          borderColor: "secondary.focus",
          color: "secondary.focus",
          boxShadow: "none",
        },

        "&:active": {
          transform: "scale(0.97)",
        },
      }}
    >
      <Icon sx={{ fontSize: 18, color: "inherit" }}>download</Icon>

      <MDTypography
        sx={{
          fontSize: "0.88rem",
          fontWeight: 700,
          color: "inherit",
          lineHeight: 1,
        }}
      >
        Descargar PDF
      </MDTypography>
    </MDBox>
  );
}
